import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.appointmentArrival.errors.";

const appointmentArrivalRuleSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    description: z.string().optional(),
  },
  { invalid_type_error: translationPath + "appointment_arrival_rule" },
);

const calendarsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const classificationsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const establishmentsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const insurancesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const proceduresSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const appointmentArrivalSchema = z.object({
  id: z.string().optional(),
  appointmentArrivalRule: appointmentArrivalRuleSchema,
  calendars: z.array(calendarsSchema).nullish(),
  classifications: z.array(classificationsSchema).nullish(),
  establishments: z.array(establishmentsSchema).nullish(),
  insurances: z.array(insurancesSchema).nullish(),
  procedures: z.array(proceduresSchema).nullish(),
});

export type TAppointmentArrivalForm = z.infer<typeof appointmentArrivalSchema>;
